import React, { useRef, type ReactNode } from 'react';
import { Text, Box } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { cssMap } from '@atlaskit/css';

type Props = {
	label: string;
	children: string | React.JSX.Element | ReactNode;
	ariaLabel?: string;
	testId?: string;
};

const styles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
	},
	label: {
		width: '96px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	valueWrapper: {
		whiteSpace: 'nowrap',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	valueStringWrapper: {
		whiteSpace: 'nowrap',
		display: 'flex',
		alignItems: 'center',
		overflow: 'hidden',
		justifyContent: 'flex-start',
		flex: '1 1 0',
	},
	textValue: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

export const PickerTriggerLayout = ({ children, label, ariaLabel, testId }: Props) => {
	const labelRef = useRef<HTMLElement | null>(null);
	const isValueTypeOfString = typeof children === 'string';

	return (
		<Box aria-label={ariaLabel} testId={testId} xcss={styles.root}>
			<Tooltip
				content={label}
				ignoreTooltipPointerEvents
				isScreenReaderAnnouncementDisabled
				canAppear={() =>
					labelRef.current !== null && labelRef.current.scrollWidth > labelRef.current.clientWidth
				}
			>
				<Box
					xcss={styles.label}
					ref={labelRef}
					testId="jql-builder-basic.common.ui.picker-trigger-layout.field-name"
				>
					<Text color="inherit" weight="bold">
						{label}
					</Text>
				</Box>
			</Tooltip>
			<Box
				xcss={isValueTypeOfString ? styles.valueStringWrapper : styles.valueWrapper}
				testId="jql-builder-basic.common.ui.picker-trigger-layout.field-value"
				paddingInlineStart="space.050"
			>
				{isValueTypeOfString ? (
					<Box xcss={styles.textValue}>
						<Text color="inherit">{children}</Text>
					</Box>
				) : (
					children
				)}
			</Box>
		</Box>
	);
};
